import { render, staticRenderFns } from "./GeneralReceipt.vue?vue&type=template&id=54d7c888"
import script from "./GeneralReceipt.vue?vue&type=script&lang=js"
export * from "./GeneralReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports